import { render, staticRenderFns } from "./PhotoCarousel.vue?vue&type=template&id=5e4259d8"
import script from "./PhotoCarousel.vue?vue&type=script&lang=js"
export * from "./PhotoCarousel.vue?vue&type=script&lang=js"
import style0 from "./PhotoCarousel.vue?vue&type=style&index=0&id=5e4259d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports